import { quatEuler, v3 } from "oc-threejs/short3";
import * as Maths3 from "oc-threejs/Maths3";
import { Part } from "../arrangement/Part";
import { ZElement } from "../arrangement/ZElement";
import { Flügel } from "../arrangement/Flügel";
import { Segment } from "../arrangement/Segment";
import { BoxRuler } from "../arrangement3d/BoxRuler";
import { getGehflügel, getStandflügel } from "../arrangement/elementFunctions";
import { getMinMaxXForSegment } from "./MHelper";
import { Box3 } from "three";

/**
 * Eigene Verwalter-Klasse für BoxRuler für den Torkonfigurator
 */
export class MassRuler {
  /**
   * Descriptions für
   * breite, gehflügelbreite, standflügelbreite, lichteweite, gesamtbreite,
   * höhe und pfostenhöhe
   */
  descriptions = {
    breite: {
      show: true,
      gridPoints: [v3(0, 1, 1), v3(1, 1, 1)],
      rulerOffset: v3(0, 0.1, 0.1),
      textOffset: v3(0, 0.02, 0),
      normal: v3(0, 0, -1),
      offsets: [0, 0, 0.1],
      offsetsFactor: 1,
      textQuaternion: Maths3.quaternion.zero,
      fontColor: "#" + APP.settings.massFarben.Breite.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: Maths3.quaternion.y180,
    },
    gehflügelbreite: {
      show: true,
      gridPoints: [v3(0, 1, 1), v3(1, 1, 1)],
      rulerOffset: v3(0, 0.1, 0.1),
      textOffset: v3(0, 0.02, 0),
      normal: v3(0, 0, -1),
      offsets: [0, 0, 0.1],
      offsetsFactor: 1,
      textQuaternion: Maths3.quaternion.zero,
      fontColor: "#" + APP.settings.massFarben.Gehflügel.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: Maths3.quaternion.y180,
    },
    standflügelbreite: {
      show: true,
      gridPoints: [v3(0, 1, 1), v3(1, 1, 1)],
      rulerOffset: v3(0, 0.1, 0.1),
      textOffset: v3(0, 0.02, 0),
      normal: v3(0, 0, -1),
      offsets: [0, 0, 0.1],
      offsetsFactor: 1,
      textQuaternion: Maths3.quaternion.zero,
      fontColor: "#" + APP.settings.massFarben.Standflügel.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: Maths3.quaternion.y180,
    },
    einzeltor: {
      show: true,
      gridPoints: [v3(0, 1, 1), v3(1, 1, 1)],
      rulerOffset: v3(0, 0.1, 0.1),
      textOffset: v3(0, 0.02, 0),
      normal: v3(0, 0, -1),
      offsets: [0, 0, 0.1],
      offsetsFactor: 1,
      textQuaternion: Maths3.quaternion.zero,
      fontColor: "#" + APP.settings.massFarben.Einzeltor.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: Maths3.quaternion.y180,
    },
    lichteweite: {
      show: true,
      gridPoints: [v3(0, 1, 1), v3(1, 1, 1)],
      rulerOffset: v3(0, 0.3, 0.1),
      textOffset: v3(0, 0.02, 0),
      normal: v3(0, 0, -1),
      offsets: [0, 0, 0.3],
      offsetsFactor: 1,
      textQuaternion: Maths3.quaternion.zero,
      fontColor: "#" + APP.settings.massFarben.LichteWeite.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: Maths3.quaternion.y180,
    },
    gesamtbreite: {
      show: true,
      gridPoints: [v3(0, 0, 1), v3(1, 0, 1)],
      rulerOffset: v3(0, -0.1, 0.1),
      textOffset: v3(0, 0.02, 0),
      normal: v3(0, 0, -1),
      offsets: [0, 0, -0.1],
      offsetsFactor: -1,
      textQuaternion: Maths3.quaternion.zero,
      fontColor: "#" + APP.settings.massFarben.Gesamtbreite.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: Maths3.quaternion.y180,
      backgroundColor: "rgba(255,255,255,0.01)", // Verhindert schwarzen Hintergrund
    },
    elementhöhe: {
      show: true,
      gridPoints: [v3(0, 0, 0), v3(0, 1, 0)],
      rulerOffset: v3(-0.2, 0, 0.5),
      textOffset: v3(-0.02, 0, 0),
      normal: v3(0, 0, 1),
      offsets: [0, 0, -0.22],
      offsetsFactor: 1,
      textQuaternion: Maths3.quaternion.z90,
      fontColor: "#" + APP.settings.massFarben.Höhe.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: quatEuler(0, 180, 90),
    },
    pfostenhöhe: {
      show: true,
      gridPoints: [v3(0, 0, 0), v3(0, 1, 0)],
      rulerOffset: v3(-0.3, 0, 0.5),
      textOffset: v3(-0.02, 0, 0),
      normal: v3(0, 0, 1),
      offsets: [0, 0, -0.3],
      offsetsFactor: 1,
      textQuaternion: Maths3.quaternion.z90,
      fontColor: "#" + APP.settings.massFarben.Pfostenhöhe.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: quatEuler(0, 180, 90),
    },
    elementhöhe_rechts: {
      show: true,
      gridPoints: [v3(1, 0, 0), v3(1, 1, 0)],
      rulerOffset: v3(0.2, 0, 0.5),
      textOffset: v3(0.02, 0, 0),
      normal: v3(0, 0, 1),
      offsets: [0, 0, 0.2],
      offsetsFactor: 1,
      textQuaternion: Maths3.quaternion.z90,
      fontColor: "#" + APP.settings.massFarben.Höhe.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: quatEuler(0, 180, 90),
    },
    pfostenhöhe_rechts: {
      show: true,
      gridPoints: [v3(1, 0, 0), v3(1, 1, 0)],
      rulerOffset: v3(0.3, 0, 0.5),
      textOffset: v3(0.02, 0, 0),
      normal: v3(0, 0, 1),
      offsets: [0, 0, 0.3],
      offsetsFactor: 1,
      textQuaternion: Maths3.quaternion.z90,
      fontColor: "#" + APP.settings.massFarben.Pfostenhöhe.getHexString(),
      isVisibleOnBackside: true,
      textQuaternionBackside: quatEuler(0, 180, 90),
    },
  };

  /**
   * Soll Front oder Back gerendert werden? Setzt dafür die Sichtbarkeit und Ausrichtung aller
   * LengthRuler anhand ihrer Description: isVisibleOnBackside und textQuaternionBackside
   * @param isFront Vorderansicht?
   */
  setSideToFront(isFront: boolean) {
    // @ts-ignore
    Scenes.getObjectsByNameRecursive("BoxRuler").forEach((object) => {
      if (!object?.objects) return;

      for (const key in object.objects) {
        const lengthRuler = object.objects[key];
        if (lengthRuler) {
          const description = object.description[key];
          lengthRuler.visible = !!(isFront || description.isVisibleOnBackside);

          if (!isFront && description.isVisibleOnBackside) {
            lengthRuler.textPlane.quaternion.copy(
              description.textQuaternionBackside || Maths3.quaternion.y180
            );
          } else {
            lengthRuler.textPlane.quaternion.copy(description.textQuaternion);
          }
        }
      }
    });
  }

  /**
   * Geht alle für den Torkonfigurator notwendigen Teile durch
   * und fügt BoxRuler hinzu mit passender Description
   * @param segment
   */
  updateRuler(segment: Segment) {
    const konf = APP.arrangement.konfiguration;
    const anMauerBeide = konf.isAnMauerBeide();
    const anMauerRechts = konf.AnMauer?.Key == "AnMauer_rechts";

    this.removeAllRuler();

    // Gesamtbreite Ruler
    this.addAndUpdateRulerForJaco(segment, { xbottom: this.descriptions.gesamtbreite }, (box) => {
      if (anMauerBeide) {
        box.min.x = segment.getXOfWorldPosition(segment.position);
        box.max.x = segment.getXOfWorldPosition(segment.position) + segment.breite;
      } else {
        const { minx, maxx } = getMinMaxXForSegment(segment);
        box.min.x = minx;
        box.max.x = maxx;
      }
    });

    const elemente = segment.getElemente() as ZElement[];
    elemente.forEach((element, index) => {
      if (element.isDoppeltor) {
        // Doppeltor-Flügelbreiten:
        this.addAndUpdateRulerForJaco(getGehflügel(element), {
          xtop: this.descriptions.gehflügelbreite,
        });
        this.addAndUpdateRulerForJaco(getStandflügel(element), {
          xtop: this.descriptions.standflügelbreite,
        });
      } else {
        if (!element.isSchiebetor) {
          // Einzeltor oder Dreifachtor-Einzeltor Breiten:
          const description = element.isDreifachtor
            ? this.descriptions.einzeltor
            : this.descriptions.breite;
          this.addAndUpdateRulerForJaco(element.flügel[0], { xtop: description });
        }
      }

      // Lichte Weite und Elementhöhe zusammen:
      let elementHöheDescription = anMauerRechts
        ? this.descriptions.elementhöhe_rechts
        : this.descriptions.elementhöhe;

      const elementDescription: any = {
        yleft: _.clone(elementHöheDescription),
      };
      if (!anMauerBeide) elementDescription.xtop = this.descriptions.lichteweite; // Bei AnMauer_beide keine LichteWeite anzeigen, da gleich zu Gesamtbreite
      if (index > 0) elementDescription.yleft.show = false; // Nur das linke Element soll Höhenruler bekommen

      this.addAndUpdateRulerForJaco(element, elementDescription, (box) => {
        const einbauAbstand = konf.getEinbauAbstand(element);
        box.min.x -= einbauAbstand / 2;
        box.max.x += einbauAbstand / 2;
      });
    });

    // Pfostenhöhe
    if (!anMauerBeide) {
      const pfosten = segment.getPfosten().find((p) => !p.anMauer);
      let description = anMauerRechts
        ? this.descriptions.pfostenhöhe_rechts
        : this.descriptions.pfostenhöhe;

      this.addAndUpdateRulerForJaco(
        pfosten as any,
        { yleft: description },
        (box) => (box.min.y = 0)
      );
    }
  }

  /**
   * Entfernt alle BoxRuler aus der Szene
   */
  private removeAllRuler() {
    (window as any).Scenes.getObjectsByNameRecursive("BoxRuler").forEach((object: any) => {
      object.parent.remove(object);
    });
  }

  /**
   * Generelle Funktion um einen Boxruler mit gewünschten descriptions einem Jaco-Object hinzuzufügen
   * @param part Teil, welches bemaßt werden soll
   * @param descriptions Beschreibung der Eigenschaften des zugrunde liegenden LengthRulers
   * @param boxUpdate Funktion, die auf die Box angewand wird beim Update
   */
  private addAndUpdateRulerForJaco(
    part: Segment | Part | Flügel,
    description: Object,
    boxUpdate?: (box: Box3) => void
  ) {
    if (!part?.jaco3d) return;

    part.massRuler = new BoxRuler();
    part.massRuler.renderOrder = 1000;
    part.jaco3d.add(part.massRuler);

    (part.massRuler as any).description = description;

    const partBox = part.getBox().clone();
    if (boxUpdate) {
      boxUpdate(partBox);
    }
    part.massRuler.updateBox(partBox);

    // renderOrder > 0 verhindert komisch aussehende Transparenz-Effekte, hat aber den Nachteil,
    // dass die Schrift durch den nicht mehr Boden sichtbar ist.
    part.massRuler.renderOrder = partBox.max.y < 0.01 ? 0 : 1000;
  }
}
